import React from 'react';

export function FacebookFeed({ className = '' }) {
  const facebookPageUrl = 'https://www.facebook.com/Jnomontage';
  
  const iframeSrc = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(
    facebookPageUrl
  )}&tabs=timeline&width=380&height=680&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

  return (
    <section className={`bg-slate-50 py-16 sm:py-24 overflow-hidden ${className}`}>
      <div className="mx-auto max-w-[1640px] px-5 sm:px-8 lg:px-12">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16">
          {/* iPhone Mockup (Left) */}
          <div className="flex justify-center lg:col-span-6 xl:col-span-5">
            {/* iPhone Mockup Frame */}
            <div className="relative mx-auto w-full max-w-[340px] sm:max-w-[380px]">
              {/* Outer Glow & Drop Shadow */}
              <div className="absolute -inset-4 rounded-[60px] bg-gradient-to-tr from-[#1877F2]/20 via-blue-400/10 to-slate-200 blur-2xl opacity-60" />

              {/* iPhone Physical Frame */}
              <div className="relative rounded-[50px] sm:rounded-[56px] border-[12px] sm:border-[14px] border-slate-900 bg-slate-900 shadow-2xl ring-1 ring-slate-800/80">
                {/* Left Side Buttons (Volume) */}
                <div className="absolute -left-[16px] sm:-left-[18px] top-28 h-10 w-[4px] rounded-l-md bg-slate-800" />
                <div className="absolute -left-[16px] sm:-left-[18px] top-42 h-10 w-[4px] rounded-l-md bg-slate-800" />
                {/* Right Side Button (Power) */}
                <div className="absolute -right-[16px] sm:-right-[18px] top-32 h-14 w-[4px] rounded-r-md bg-slate-800" />

                {/* Phone Screen Container */}
                <div className="relative overflow-hidden rounded-[38px] sm:rounded-[42px] bg-white pt-2">
                  
                  {/* Status Bar / Notch Area */}
                  <div className="relative z-30 flex h-10 items-center justify-between px-6 pt-1 text-slate-900 select-none bg-white">
                    {/* Time */}
                    <span className="text-[12px] font-semibold tracking-tight text-slate-800">09:41</span>
                    
                    {/* Dynamic Island */}
                    <div className="absolute left-1/2 top-2 h-5 w-24 -translate-x-1/2 rounded-full bg-black px-2.5 flex items-center justify-end gap-1.5 shadow-sm">
                      <div className="h-2 w-2 rounded-full bg-slate-900 border border-slate-700/50" />
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-900/40" />
                    </div>

                    {/* Status Icons */}
                    <div className="flex items-center gap-1.5 text-[11px] text-slate-700">
                      <i className="fa-solid fa-signal text-[10px]" />
                      <i className="fa-solid fa-wifi text-[10px]" />
                      <i className="fa-solid fa-battery-full text-[12px]" />
                    </div>
                  </div>

                  {/* App Header Bar inside iPhone */}
                  <div className="relative z-20 flex items-center justify-between border-b border-slate-100 bg-slate-50/90 backdrop-blur-sm px-4 py-2.5">
                    <div className="flex items-center gap-2.5">
                      <div className="flex h-7 w-7 items-center justify-center rounded-full bg-[#1877F2] text-white shadow-xs">
                        <i className="fa-brands fa-facebook-f text-xs" aria-hidden="true" />
                      </div>
                      <span className="text-xs font-bold text-slate-900">JNO Montage</span>
                    </div>
                    <a
                      href={facebookPageUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded-full bg-[#1877F2] px-3 py-1 text-[11px] font-semibold text-white shadow-xs hover:bg-[#1877F2]/90"
                    >
                      Åbn app
                    </a>
                  </div>

                  {/* Feed Container with iframe */}
                  <div className="relative h-[560px] sm:h-[620px] w-full bg-slate-50 overflow-y-auto overflow-x-hidden">
                    {/* Live Facebook Page Iframe */}
                    <iframe
                      src={iframeSrc}
                      width="100%"
                      height="680"
                      style={{ border: 'none', overflow: 'hidden' }}
                      scrolling="no"
                      frameBorder="0"
                      allowFullScreen={true}
                      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                      title="JNO Montage Facebook Feed"
                      className="w-full relative z-10"
                    />

                    {/* Fallback Banner beneath iframe if blocked by browser/Facebook privacy policies */}
                    <div className="absolute inset-0 z-0 flex flex-col items-center justify-center p-6 text-center bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white">
                      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#1877F2] text-white shadow-lg mb-4 ring-4 ring-white/10">
                        <i className="fa-brands fa-facebook-f text-2xl" aria-hidden="true" />
                      </div>
                      <h3 className="text-lg font-bold text-white">JNO Montage på Facebook</h3>
                      <p className="mt-2 text-xs text-slate-300 leading-relaxed max-w-[260px]">
                        Se vores seneste billeder, opdateringer og nyheder fra montageprojekter.
                      </p>
                      <a
                        href={facebookPageUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-5 inline-flex items-center gap-2 rounded-xl bg-[#1877F2] px-5 py-2.5 text-xs font-semibold text-white shadow-md transition hover:bg-[#1877F2]/90"
                      >
                        <i className="fa-brands fa-facebook" aria-hidden="true" />
                        Åbn JNO Montage på Facebook
                      </a>
                    </div>
                  </div>

                  {/* Home Indicator Bar at bottom */}
                  <div className="relative z-30 flex h-6 items-center justify-center bg-white pb-1">
                    <div className="h-1 w-32 rounded-full bg-slate-900/30" />
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* Text Content (Right) */}
          <div className="lg:col-span-6 xl:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#1877F2]/10 px-4 py-1.5 text-xs font-semibold text-[#1877F2]">
              <i className="fa-brands fa-facebook text-sm" aria-hidden="true" />
              <span>Facebook Opdateringer</span>
            </div>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-[#0B0E14] sm:text-4xl lg:text-[42px] lg:leading-tight">
              Følg JNO Montage på Facebook
            </h2>
            <p className="mt-5 text-base leading-8 text-slate-600 sm:text-lg">
              Hold dig opdateret med vores seneste projekter, gode råd om energioptimering, billeder fra dagligdagen og nyheder direkte fra vores Facebook-side.
            </p>

            <div className="mt-8 space-y-4">
              <div className="flex items-start gap-3.5">
                <div className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#1877F2]/10 text-[#1877F2]">
                  <i className="fa-light fa-images text-base" aria-hidden="true" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#0B0E14]">Projekter & Installationer</h3>
                  <p className="text-sm text-slate-600">Se billeder og eksempler på vores udskiftning af varmepumper, pillefyr og solcelleanlæg.</p>
                </div>
              </div>

              <div className="flex items-start gap-3.5">
                <div className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#1877F2]/10 text-[#1877F2]">
                  <i className="fa-light fa-newspaper text-base" aria-hidden="true" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#0B0E14]">Nyheder & Gode Råd</h3>
                  <p className="text-sm text-slate-600">Følg med i sæsonens tips til vedligeholdelse og energioptimering af dit varmeanlæg.</p>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href={facebookPageUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 rounded-xl bg-[#1877F2] px-7 py-4 text-sm font-semibold text-white shadow-md shadow-[#1877F2]/20 transition hover:bg-[#1877F2]/90"
              >
                <i className="fa-brands fa-facebook text-lg" aria-hidden="true" />
                Besøg Facebook-side
                <i className="fa-light fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
